import { render } from "./HeaderFive.vue?vue&type=template&id=03153dcc"
import script from "./HeaderFive.vue?vue&type=script&lang=js"
export * from "./HeaderFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__